"use client";

import React from "react";
import Toast from "../Toast";
import { useToast } from "@/hooks/useToast";

const Toaster = () => {
    const { toasts, removeToast } = useToast();

    if (!toasts) {
        return null;
    }

    return (
        <div className="w-[25rem] fixed bottom-0 right-0 p-100 space-y-100 z-[10000]">
            {toasts.map((toastItem) => (
                <Toast
                    id={toastItem.id}
                    key={toastItem.id}
                    title={toastItem.title}
                    status={toastItem.status}
                    href={toastItem.href}
                    removeToast={removeToast}
                />
            ))}
        </div>
    );
};

export default Toaster;
